<template>
  <div class="my-12">
    <h1 class="pt-0 pb-6 font-5xl tracking-wide leading-loose font-semibold text-center uppercase">
      {{ brand.name }}’S PLANS COME WITH THESE GREAT FEATURES:
    </h1>

    <div class="flex-wrap flex flex-row sm:flex-no-wrap justify-center content-container">
      <div class="w-full text-center px-3">
        <rocket-icon class="m-auto stroke-current text-brand-colour-alt" />
        <p class="font-bold uppercase pt-5 pb-2">
          Fast Speeds
        </p>
        <p class="leading-normal mb-5">
          Connect lots of devices all at the one time with our super-fast internet speeds.
        </p>
      </div>

      <div class="w-full text-center px-3">
        <fast-setup class="m-auto stroke-current text-brand-colour-alt" />
        <p class="font-bold uppercase pt-5 pb-2">
          Fast, Easy Setup
        </p>
        <p class="leading-normal mb-5">
          Have a hassle-free setup with step-by-step instructions for your new connection.
        </p>
      </div>

      <div class="w-full text-center px-3">
        <local-support class="m-auto stroke-current text-brand-colour-alt" />
        <p class="font-bold uppercase pt-5 pb-2">
          Friendly Support
        </p>
        <p class="leading-normal mb-5">
          Our friendly, install technicians aim to have you up and running on the same day.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import RocketIcon from '~/components/Icons/Rocket.vue'
import LocalSupport from '~/components/Icons/LocalSupport.vue'
import FastSetup from '~/components/Icons/FastSetup.vue'

export default {
  components: {
    RocketIcon,
    LocalSupport,
    FastSetup
  },
  data() {
    return {
      siteId: process.env.siteId,
      brand: process.env.brand
    }
  }
}
</script>
